import { __rest } from "tslib";
import { Input } from 'antd';
import React from 'react';
import pasteInputHoc from '../PasteInput/PasteInput';
import MeetingRoomLocation from '../LocationInput/LocationInput';
const PasteInput = pasteInputHoc(Input);
const LocationInput = props => {
    const { meetingRoomEnable, suffix, renderSelectMeetingRoom, meetingRoomSelected, meetingRoomLocationProps } = props, rest = __rest(props, ["meetingRoomEnable", "suffix", "renderSelectMeetingRoom", "meetingRoomSelected", "meetingRoomLocationProps"]);
    if (!meetingRoomSelected) {
        return React.createElement(PasteInput, Object.assign({ suffix: meetingRoomEnable ? renderSelectMeetingRoom() : suffix }, rest));
    }
    return React.createElement(MeetingRoomLocation, Object.assign({ value: props.value, id: rest.id }, meetingRoomLocationProps));
};
export default LocationInput;
